import React, {createContext} from "react";

const HolidaysContext = createContext({});

export default HolidaysContext;